module.exports = __webpack_public_path__ + "img/pwa-role-select-hen.12f9d5af.png";